(function (tagName) {
  if (customElements.get(tagName)) return;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshNativeCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function reportPairIntegrityFailure(reason) {
    document.dispatchEvent(new CustomEvent('apc:cart-integrity-failure', {
      detail: { operation: 'add', outcome: 'exception', reason: reason }
    }));
  }

  function verifyPersonalizedPair(items, pairId, requestedQuantity) {
    if (!Array.isArray(items)) {
      reportPairIntegrityFailure('verification_unavailable');
      return;
    }

    var pair = items.filter(function (item) {
      return item.properties && item.properties._apc_pair_id === pairId;
    });
    var collarCount = pair.filter(function (item) { return item.properties._cf_ !== 'addonProduct'; }).length;
    var addonCount = pair.filter(function (item) { return item.properties._cf_ === 'addonProduct'; }).length;
    var quantitiesMatch = pair.length === 2 && pair.every(function (item) {
      return Number(item.quantity) === Number(requestedQuantity);
    });
    if (collarCount !== 1 || addonCount !== 1 || !quantitiesMatch) {
      reportPairIntegrityFailure('pair_mismatch');
    }
  }

  function renderBundledCartSection(sectionHtml) {
    if (typeof sectionHtml !== 'string' || !sectionHtml) return false;

    var drawer = document.querySelector('cart-element[data-cart-drawer]');
    if (!drawer || typeof drawer.build !== 'function') return false;
    if (!drawer.isCartDrawerLoaded && typeof drawer.renderCartDrawer === 'function') {
      drawer.renderCartDrawer(false);
    }

    var response = document.createElement('div');
    response.innerHTML = sectionHtml;
    var content = response.querySelector('[data-api-content]');
    if (!content) return false;

    drawer.build(content);
    return true;
  }

  class CustomizeProducts extends HTMLElement {
    connectedCallback() {
      this.initialize();
    }

    disconnectedCallback() {
      this.teardown();
    }

    initialize() {
      if (this._initialized) return;

      this.form = this.closest('form');
      this.mainSelect = this.querySelector('[data-main-select]');
      this.btnAdd = this.form && this.form.querySelector('[name="add"]');
      this.productInputId = this.form && this.form.querySelector('[data-product-select]');
      this.productInputQuantity = this.form && this.form.querySelector('[name="quantity"]');

      if (!this.form || !this.btnAdd || !this.productInputId) return;

      this._initialized = true;
      this._adding = false;
      this._variantRequestId = 0;
      this._variantController = null;
      this._lastVariantId = String(this.productInputId.value || '');
      this._customizationReady = true;

      this._onVariantInputChange = (event) => this.handleVariantChange(event.target.value);
      this._onVariantValueMutation = () => this.handleVariantChange(this.productInputId.value);
      this._onVariantPoll = () => {
        if (!document.hidden) this.handleVariantChange(this.productInputId.value);
      };
      this._onVisibilityChange = () => {
        if (!document.hidden) this.handleVariantChange(this.productInputId.value);
      };
      this._onSelectChange = (event) => {
        if (event.target && event.target.hasAttribute('data-main-select')) {
          this.mainSelect = event.target;
          this.applyDropdownState();
        }
      };
      this._onAddClick = (event) => this.handleCustomizedIntent(event);
      this._onFormSubmit = (event) => this.handleCustomizedIntent(event);

      this.productInputId.addEventListener('change', this._onVariantInputChange);
      this._variantInputObserver = new MutationObserver(this._onVariantValueMutation);
      this._variantInputObserver.observe(this.productInputId, {
        attributes: true,
        attributeFilter: ['value']
      });
      this._variantPoller = window.setInterval(this._onVariantPoll, 750);
      document.addEventListener('visibilitychange', this._onVisibilityChange);
      this.addEventListener('change', this._onSelectChange);
      this.btnAdd.addEventListener('click', this._onAddClick);
      this.form.addEventListener('submit', this._onFormSubmit, true);

      this.applyDropdownState();
    }

    teardown() {
      if (!this._initialized) return;

      this._initialized = false;
      this._variantRequestId += 1;
      if (this._variantController) this._variantController.abort();
      if (this._variantInputObserver) this._variantInputObserver.disconnect();
      if (this._variantPoller) window.clearInterval(this._variantPoller);

      document.removeEventListener('visibilitychange', this._onVisibilityChange);
      this.removeEventListener('change', this._onSelectChange);
      this.btnAdd.removeEventListener('click', this._onAddClick);
      this.form.removeEventListener('submit', this._onFormSubmit, true);
      this.productInputId.removeEventListener('change', this._onVariantInputChange);

      this._variantController = null;
      this._variantInputObserver = null;
      this._variantPoller = null;
    }

    isCustomized() {
      if (!this.mainSelect || this.mainSelect.selectedIndex <= 0) return false;
      var option = this.mainSelect.options[this.mainSelect.selectedIndex];
      return Boolean(option && option.dataset.productId);
    }

    applyDropdownState() {
      var selectedOption = this.mainSelect && this.mainSelect.options[this.mainSelect.selectedIndex];
      var productId = selectedOption && selectedOption.dataset.productId;
      this.selectedDropdownFieldsItem = null;

      Array.from(this.querySelectorAll('[data-dropdown-fields-item]')).forEach((item) => {
        var selected = Boolean(productId && item.dataset.productId === productId);
        item.classList.toggle('hidden', !selected);
        item.querySelectorAll('input, select').forEach((field) => {
          field.toggleAttribute('disabled', !selected);
        });
        if (selected) this.selectedDropdownFieldsItem = item;
      });

      this.toggleDynamicCheckout(!this.isCustomized());
    }

    handleVariantChange(variantId) {
      var nextVariantId = String(variantId || '');
      if (!nextVariantId || nextVariantId === this._lastVariantId) return;

      this._lastVariantId = nextVariantId;
      this.setCustomizationPending();
      this.loadVariantCustomizations(nextVariantId);
    }

    loadVariantCustomizations(variantId) {
      var handle = this.dataset.productHandle;
      if (!handle) return;

      var requestId = ++this._variantRequestId;
      if (this._variantController) this._variantController.abort();
      this._variantController = typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;

      var url = new URL(cartRoot() + 'products/' + encodeURIComponent(handle), window.location.origin);
      url.searchParams.set('variant', variantId);
      var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

      var options = this._variantController ? { signal: this._variantController.signal } : {};
      fetch(url.toString(), options)
        .then((response) => {
          if (!response.ok) throw new Error('Product request failed: ' + response.status);
          return response.text();
        })
        .then((data) => {
          if (!this.isCurrentVariantRequest(requestId, variantId)) return;

          var html = new DOMParser().parseFromString(data, 'text/html');
          var customizeElement = html.querySelector(tagName);
          if (!customizeElement) {
            this.clearCustomization();
            return;
          }

          var previousSelection = this.mainSelect ? this.mainSelect.value : 'None';
          if (this.innerHTML !== customizeElement.innerHTML) {
            this.innerHTML = customizeElement.innerHTML;
          }

          this.mainSelect = this.querySelector('[data-main-select]');
          this.setCustomizationReady();
          this.restoreSelection(previousSelection);
          this.applyDropdownState();
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          if (!this.isCurrentVariantRequest(requestId, variantId)) return;
          console.error('Unable to refresh customization options:', error);
          alert('Unable to load customization options. Please try again.');
        });
    }

    isCurrentVariantRequest(requestId, variantId) {
      return this.isConnected
        && requestId === this._variantRequestId
        && this.productInputId
        && String(this.productInputId.value || '') === String(variantId);
    }

    setCustomizationPending() {
      this._customizationReady = false;
      this.selectedDropdownFieldsItem = null;
      this.querySelectorAll('input, select').forEach((field) => {
        field.disabled = true;
      });
      this.toggleDynamicCheckout(false);
      this.btnAdd.disabled = true;
      this.btnAdd.setAttribute('aria-busy', 'true');
    }

    setCustomizationReady() {
      this._customizationReady = true;
      this.btnAdd.disabled = Boolean(this._adding);
      this.btnAdd.removeAttribute('aria-busy');
    }

    clearCustomization() {
      this.replaceChildren();
      this.mainSelect = null;
      this.selectedDropdownFieldsItem = null;
      this.setCustomizationReady();
      this.toggleDynamicCheckout(true);
    }

    restoreSelection(previousSelection) {
      if (!this.mainSelect || !previousSelection || previousSelection === 'None') return;

      var prefix = String(previousSelection).split(' +')[0];
      var matchingOption = Array.from(this.mainSelect.options).find((option) => {
        return option.value === previousSelection || option.value.indexOf(prefix + ' +') === 0;
      });
      if (matchingOption) this.mainSelect.value = matchingOption.value;
    }

    validateCustomization() {
      if (!this.selectedDropdownFieldsItem) return true;

      var missing = Array.from(this.selectedDropdownFieldsItem.querySelectorAll('[required]:not([disabled])'))
        .find((field) => !String(field.value || '').trim());
      if (!missing) return true;

      var label = missing.labels && missing.labels[0] && missing.labels[0].textContent;
      alert('Please fill out the "' + (label || 'required') + '" field.');
      missing.classList.add('field-error');
      missing.focus();
      window.scrollBy(0, missing.getBoundingClientRect().y - 150);
      missing.addEventListener('blur', () => missing.classList.remove('field-error'), { once: true });
      return false;
    }

    handleCustomizedIntent(event) {
      if (!this._customizationReady) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!this.isCustomized()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (this._adding) return;
      if (typeof this.form.reportValidity === 'function' && !this.form.reportValidity()) return;
      if (!this.validateCustomization()) return;

      this.addCustomizedPair();
    }

    addCustomizedPair() {
      var selectedOption = this.mainSelect.options[this.mainSelect.selectedIndex];
      var addonVariantId = selectedOption && selectedOption.dataset.productId;
      if (!addonVariantId) return;

      // Shopify quantities must be positive integers.
      var requestedQuantity = Number(this.productInputQuantity ? this.productInputQuantity.value : 1);
      var quantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0
        ? Math.floor(requestedQuantity)
        : 1;
      var pairId = 'apc_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      var addon = {
        id: addonVariantId,
        quantity: quantity,
        properties: { _cf_: 'addonProduct', _apc_pair_id: pairId }
      };
      var collar = {
        id: this.productInputId.value,
        quantity: quantity,
        properties: { _apc_pair_id: pairId }
      };

      this.form.querySelectorAll('[name^="options"]:checked').forEach((radio) => {
        addon.properties['_' + radio.name.slice(8, -1)] = radio.value;
      });
      this.form.querySelectorAll('[name^="properties"]:not([disabled])').forEach((field) => {
        var name = field.name.slice(11, -1);
        addon.properties['_' + name] = field.value;
        collar.properties[name] = field.value;
      });

      this._adding = true;
      this.btnAdd.classList.add('is-loading');
      this.btnAdd.disabled = true;

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [addon, collar],
          sections: ['api-cart-items'],
          sections_url: cartRoot() + 'cart'
        })
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart add failed: ' + response.status);
          return response.json();
        })
        .then((data) => {
          verifyPersonalizedPair(data && data.items, pairId, quantity);
          try {
            if (renderBundledCartSection(data && data.sections && data.sections['api-cart-items'])) return;
          } catch (error) {
            console.error('Unable to render bundled cart section:', error);
          }
          refreshNativeCart();
        })
        .catch((error) => {
          console.error('Customized cart add failed:', error);
          alert('Something went wrong adding this to your cart. Please try again.');
        })
        .finally(() => {
          this._adding = false;
          this.btnAdd.classList.remove('is-loading');
          this.btnAdd.disabled = !this._customizationReady;
          if (this._customizationReady) this.btnAdd.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('theme:cart-bar:reset-atc-animation', { bubbles: true }));
        });
    }

    toggleDynamicCheckout(isEnabled) {
      var paymentWrapper = this.form && this.form.querySelector('.shopify-payment-button');
      if (paymentWrapper) paymentWrapper.style.display = isEnabled ? '' : 'none';
    }
  }

  customElements.define(tagName, CustomizeProducts);
})('customize-products');
